export const consonantTypes = new Set(['boolean', 'number', 'string']);
export const vowelTypes = new Set(['integer', 'array', 'object']);
